// Horizontal location of the snackbar

export const LEFT = "left";
export const CENTER = "center";
export const RIGHT = "right";